module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider2Post-3ce1739d.jpeg";